//@ts-nocheck

import React from 'react';
import CheckBoxButton from 'components/AntdFormInputs/checkbox-button';
import { Label } from 'reactstrap';

const MultipleChoice = ({ question = [], value = [], onChange, readOnly }) => {
  const handleChange = (selectedIndex) => {
    if (readOnly) return;
    const newValue = question.map((_, index) => index === selectedIndex);
    onChange(newValue);
  };

  return (
    <>
      {question.map((quiz, index) => {
        const isSelected = value?.[index] === true;

        return (
          <Label
            key={quiz?._id ?? index}
            htmlFor={`MTP-${index}`}
            className="multiple-checkbox explanation-card pr-0"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              cursor: readOnly ? 'default' : 'pointer',
            }}
          >
            <CheckBoxButton
              type="radio"
              id={`MTP-${index}`}
              name="MTP"
              checked={isSelected}
              disabled={readOnly}
              onChange={() => handleChange(index)}
            />

            <span className="multiple-choice-ans-radio multiple-choice-card drag-overflow-image">
              <span
                dangerouslySetInnerHTML={{
                  __html: quiz?.content ?? '',
                }}
              />
            </span>
          </Label>
        );
      })}
    </>
  );
};

export default MultipleChoice;
